import { useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import useFirebaseNotifications from "./hooks/useFirebaseNotifications";
import Home from "./features/jacana/pages/Home";
import AdminDashboard from "./features/jacana/pages/AdminDashboard";
import CreateOuting from "./features/jacana/pages/CreateOuting";
import OutingDetail from "./features/jacana/pages/OutingDetail";
import Navbar from "./features/jacana/components/Navbar";
import RequireClaimRoute from "./features/users/components/RequireClaimRoute";
import RequireAdminRoute from "./features/users/components/RequireAdminRoute";
import UsersAdminPage from "./features/users/pages/UsersAdminPage";
import HomeSettingsPage from "./features/jacana/pages/HomeSettingsPage";
import NewsletterInfoPage from "./features/jacana/pages/NewsletterInfoPage";
import Login from "./pages/Login";
import MyBookings from "./features/jacana/pages/MyBookings";
import LegalDocumentPage from "./features/legal/pages/LegalDocumentPage";
import ConsentSettingsPage from "./features/legal/pages/ConsentSettingsPage";
import CookiePolicyPage from "./features/legal/pages/CookiePolicyPage";
import CookieConsentBanner from "./features/legal/components/CookieConsentBanner";
import LegalReacceptanceBanner from "./features/legal/components/LegalReacceptanceBanner";
import HelpDrawer from './features/help/components/HelpDrawer';
import PoweredByZalb from './features/jacana/components/PoweredByZalb';
import { Toaster } from 'react-hot-toast';
import { AnimatePresence } from 'framer-motion';

function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.hash) {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  // Call the hook but we don't need the return here if we don't trigger it globally
  useFirebaseNotifications();

  return (
    <div className="min-h-screen bg-brand-paper flex flex-col">
      <ScrollToTop />
      <Navbar />
      <LegalReacceptanceBanner />
      <HelpDrawer />
      <Toaster
        position="top-center"
        gutter={12}
        toastOptions={{
          className: 'font-sans text-[15px] md:text-base leading-relaxed border border-brand-primary/10 shadow-2xl rounded-[24px] px-4 py-3',
          duration: 5000,
          style: {
            maxWidth: '560px',
            background: '#ffffff',
            color: '#243428',
          },
          success: {
            iconTheme: {
              primary: '#3f8f5b',
              secondary: '#ffffff',
            },
          },
          error: {
            iconTheme: {
              primary: '#c24141',
              secondary: '#ffffff',
            },
          },
        }}
      />
      
      <div className="flex-1">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/mes-reservations" element={<MyBookings />} />
            <Route path="/mes-reservations/:id" element={<MyBookings />} />
            <Route path="/mes-consentements" element={<ConsentSettingsPage />} />
            <Route path="/share/outing/:id" element={<OutingDetail />} />
            <Route path="/outing/:id" element={<OutingDetail />} />
            <Route path="/cgv" element={<LegalDocumentPage />} />
            <Route path="/confidentialite" element={<LegalDocumentPage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            <Route path="/admin" element={<RequireClaimRoute allowedRoles={["Admin", "Patron", "Developpeur"]}><AdminDashboard /></RequireClaimRoute>} />
            <Route path="/admin/home-settings" element={<RequireClaimRoute allowedRoles={["Admin", "Patron", "Developpeur"]}><HomeSettingsPage /></RequireClaimRoute>} />
            <Route path="/admin/newsletter-info" element={<RequireClaimRoute allowedRoles={["Admin", "Patron", "Developpeur"]}><NewsletterInfoPage /></RequireClaimRoute>} />
            <Route path="/admin/users" element={<RequireAdminRoute><UsersAdminPage /></RequireAdminRoute>} />
            <Route path="/admin/create" element={<RequireClaimRoute allowedRoles={["Admin", "Patron", "Developpeur"]}><CreateOuting /></RequireClaimRoute>} />
            <Route path="/admin/edit/:id" element={<RequireClaimRoute allowedRoles={["Admin", "Patron", "Developpeur"]}><CreateOuting /></RequireClaimRoute>} />
          </Routes>
        </AnimatePresence>
      </div>

      {!isAdminRoute ? <PoweredByZalb /> : null}
      <CookieConsentBanner />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
